import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient,HttpHeaders} from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class DisputesService {

  constructor(public http: HttpClient) { }

  	getDisputeslist(id,datatype){
  		var token = environment.token;
        var apiURL = environment.apiURL + 'complaints?data_id='+id+'&data_type='+datatype+'';
        let newheader = this.getHeaders(token);
        return this.http.get(apiURL, {headers:newheader});
    }

	getHeaders(token) {
  		const header = {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };      
        let headers = new HttpHeaders(header);
        if (token != undefined) {
            let newheader = headers.append('Authorisation',token);
            return newheader;
        }
        else{
            return headers;
        }
    }

    /**
    * Method: adddispute
    * Action: To save notes as case action
    * @param token {string} - authorized token
    * @param data {object} - case note
    * @param case_id {int} - Case ID
    * @returns API response
    */
   adddispute(formdata)
   {
      var token = environment.token;
      var apiURL = environment.apiURL + 'complaints/create';
      let newheader = this.getHeaders(token);
      return this.http.post(apiURL,formdata,{headers:newheader});
   }

   getReplieslist(data_id){
     var token = environment.token;
        var apiURL = environment.apiURL + 'messages/getComplaintReplies?data_id='+data_id+'';
        let newheader = this.getHeaders(token);
        return this.http.get(apiURL, {headers:newheader});
   }
}
